import { render, staticRenderFns } from "./S3image.vue?vue&type=template&id=0f031683&scoped=true&"
import script from "./S3image.vue?vue&type=script&lang=js&"
export * from "./S3image.vue?vue&type=script&lang=js&"
import style0 from "./S3image.vue?vue&type=style&index=0&id=0f031683&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f031683",
  null
  
)

export default component.exports